import React from "react";
import { useLocation } from "react-router-dom";
import { logo } from "utils/importFile";
import { AnimationCommon } from "..";
import { bg } from "utils/importFile";
interface AuthLayoutProps {
  children: React.ReactNode;
}
const AuthLayout = ({ children }: AuthLayoutProps) => {
  const location = useLocation();

  return (
    <>
      <div className="flex items-center justify-center w-[100%]">
        <div className="min-h-screen bg-cover bg-center backdrop-blur-md w-[100%]">
          <img src={bg} alt="Logo" className="w-full h-[100vh] object-cover" />
          <div className="absolute bottom-[47px] left-[27px] lg:left-[47px] 2xl:left-[78px] text-[var(--textWhite)] max-w-[80%]">
            <h1 className="text-[40px] text-[var(--textWhite)] font-[700] !mb-[12px] leading-[48px]">
              NHANH CHÓNG & TIỆN LỢI
            </h1>
            <p className="text-[18px] leading-[26px]">
              Chúng tôi luôn mang đến cho khách hàng một dịch vụ tuyệt vời nhất,
              hỗ trợ tận tâm tận tình. Giúp cho trải nghiệm khách hàng trên cả
              tuyệt vời
            </p>
            <div className="mt-[12px] flex items-center gap-[2px]">
              <div className="w-[18px] h-[18px] bg-[var(--textWhite)] rounded-full"></div>
              <div className="w-[18px] h-[18px] bg-[var(--textWhite)] rounded-full"></div>
              <div className="w-[54px] h-[18px] bg-[var(--textWhite)] rounded-full"></div>
            </div>
          </div>
        </div>
        <AnimationCommon
          effect="fadeDown"
          transition="slow"
          presenceMode="wait"
          presenceKey={location.pathname}
          disablePresence={false}
          className="flex items-center justify-center h-screen"
        >
          <div className="bg-[var(--textWhite)] p-[24px] rounded-[16px] gap-[10px]">
            <div className="p-[24px] rounded-[16px] gap-[24px] flex flex-col items-center">
              <div className="text-center">
                <img src={logo} alt="Logo" className="mx-auto max-w-[200px]" />
              </div>
              <div className="w-[420px]">{children}</div>
            </div>
          </div>
        </AnimationCommon>
      </div>
    </>
  );
};

export default AuthLayout;
